export default "__VITE_ASSET__CP_RsOoZ__"